import React, { useState } from 'react';
import './Header.css'
import logo from  '../../assets/logos/logo_horizontal-sem_fundo.png'

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <img src={logo} alt="LKSME Serviços Gerais" />

      {/* Botão Hambúrguer (Visível apenas no Mobile) */}
      <button 
        className={`hamburger ${isMenuOpen ? 'open' : ''}`} 
        onClick={toggleMenu}
        aria-label="Toggle Menu"
      >
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </button>

      {/* Navegação */}
      <nav className={`header-nav ${isMenuOpen ? 'active' : ''}`}>
        <ul className="header-links">
          <li><a href="#home" onClick={() => setIsMenuOpen(false)}>Início</a></li>
          <li><a href="#sobre" onClick={() => setIsMenuOpen(false)}>Sobre Nós</a></li>
          <li><a href="#portifolio" onClick={() => setIsMenuOpen(false)}>Serviços</a></li>
          <li><a href="#sobre" onClick={() => setIsMenuOpen(false)}>Contato</a></li>
        </ul>
      </nav>
    </header>
  );
}